import * as filters from '@/filters';
import Vue from 'vue'; // global filters

Vue.prototype.filters = filters;
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});
